(function () {
  var overlay = document.getElementById('intro-animation');
  if (!overlay) return;

  var STORAGE_KEY = 'introAnimationPlayed';

  function removeOverlay() {
    if (overlay && overlay.parentNode) {
      overlay.parentNode.removeChild(overlay);
    }
  }

  // Belt-and-suspenders: no matter what goes wrong below, the overlay
  // is guaranteed to be gone shortly after the rest of the script runs.
  setTimeout(removeOverlay, 8000);

  try {
    if (window.Shopify && Shopify.designMode) {
      removeOverlay();
      return;
    }

    var alreadyPlayed = false;
    try {
      alreadyPlayed = !!sessionStorage.getItem(STORAGE_KEY);
      sessionStorage.setItem(STORAGE_KEY, 'true');
    } catch (storageError) {
      // Storage blocked (private browsing, locked-down browser, etc.) —
      // fail safe by skipping the animation rather than risking a stuck overlay.
      removeOverlay();
      return;
    }

    if (alreadyPlayed) {
      removeOverlay();
      return;
    }

    var reduceMotion = false;
    try {
      reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (mediaError) {
      reduceMotion = false;
    }

    if (reduceMotion) {
      removeOverlay();
      return;
    }

    var logo = overlay.querySelector('.intro-animation__logo');
    var target = document.querySelector('.header__heading-logo');

    if (!logo || !target) {
      removeOverlay();
      return;
    }

    function playAnimation() {
      try {
        var targetRect = target.getBoundingClientRect();
        var logoRect = logo.getBoundingClientRect();

        if (!targetRect.width || !logoRect.width) {
          removeOverlay();
          return;
        }

        var scale = targetRect.width / logoRect.width;
        var deltaX = targetRect.left + targetRect.width / 2 - (logoRect.left + logoRect.width / 2);
        var deltaY = targetRect.top + targetRect.height / 2 - (logoRect.top + logoRect.height / 2);

        logo.style.transform = 'translate(' + deltaX + 'px, ' + deltaY + 'px) scale(' + scale + ')';

        var settled = false;
        function settle() {
          if (settled) return;
          settled = true;
          overlay.classList.add('intro-animation--exit');
          overlay.addEventListener('transitionend', removeOverlay, { once: true });
          setTimeout(removeOverlay, 1400);
        }

        logo.addEventListener('transitionend', settle, { once: true });
        setTimeout(settle, 1400);
      } catch (playError) {
        removeOverlay();
      }
    }

    var HOLD_MS = 1500;
    var MAX_WAIT_FOR_LOAD_MS = 4000;
    var started = false;

    function startSequence() {
      if (started) return;
      started = true;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          setTimeout(playAnimation, HOLD_MS);
        });
      });
    }

    // Don't let a slow-loading resource (e.g. a large background video)
    // hold the splash hostage — start once the page loads, or after a
    // reasonable ceiling, whichever comes first.
    window.addEventListener('load', startSequence);
    setTimeout(startSequence, MAX_WAIT_FOR_LOAD_MS);
  } catch (fatalError) {
    removeOverlay();
  }
})();
